var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/* HOOK */
export function useTimer(config) {
    var timer = React.useRef(null);
    return {
        cancel: function () {
            timer.current && clearTimeout(timer.current);
        },
        reset: function () {
            timer.current && clearTimeout(timer.current);
        },
        setTimer: function (callback, duration) {
            timer.current && clearTimeout(timer.current);
            timer.current = window.setTimeout(callback, duration);
        },
        timerId: timer.current,
    };
}
/* DECORATOR */
export function withTimer(config) {
    return function (Component) {
        return function WithTimer(props) {
            return (React.createElement(Component, __assign({}, props, { timer: useTimer(__assign(__assign({}, config), props.timer)) })));
        };
    };
}
/* RENDER PROP */
export function Timer(_a) {
    var children = _a.children;
    var timer = useTimer({});
    return typeof children === 'function' ? children(timer) : children;
}
/* CONTEXT */
var noop = function (method) { return function () {
    return console.warn("Could not call `" + method + "`, please wrap your component in a `<TimerProvider>`");
}; };
export var TimerContext = React.createContext({
    cancel: noop('cancel'),
    reset: noop('reset'),
    setTimer: noop('setTimer'),
    timerId: null,
});
export function TimerProvider(_a) {
    var children = _a.children;
    return (React.createElement(TimerContext.Provider, { value: useTimer({}) }, children));
}
export function useTimerContext() {
    return React.useContext(TimerContext);
}
export var consumeTimer = useTimerContext;
//# sourceMappingURL=Timer.js.map